import React from "react";
import APIService from "../../Service/APIService";
import { Button, Input, Pagination, Flex, Spin, Skeleton } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import Config from "../../Config/Config.js";
import {
  CloseCircleOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import TitleBar from "../../common/title-bar/title-bar.js";
import Table from "../../common/table/index.js";
import TableLink from "../../common/table/table-link/index.js";
import TableOptionsCell from "../../common/table/table-options-cell/index.js";
import { colors } from "../../theme/colors.js";
import { useAuth } from "../AuthProvider";
import { hasPermission } from "../../Config/permissions.js";
import Tags from "../../common/tags/index.js";
import CommonButton from "../../common/button/button.js";
import { canSubmitAccountEnrollment } from "../AccountEnrollment/accountEnrollmentAccess.js";
import FilteredViewChip from "../../common/filtered-view-chip/index.js";
import {
  ACCOUNTS_LINK_KEYS,
  ACCOUNT_ACTIVITY_LABELS,
  PAST_DUE_THRESHOLD_LABELS,
  filterChipClearLabel,
  filterChipLabel,
  formatDateRangeLabel,
  readAccountsLinkFilters,
  withoutKeys,
} from "../AABI/landingFilters";

const components = {
  header: {
    cell: ({ style, ...restProps }) => (
      <th
        {...restProps}
        style={{
          ...style,
          backgroundColor: "#000a7b",
          color: "#fff",
        }}
      />
    ),
  },
};

const AccountDashboard = () => {
  const [columns, setColumns] = React.useState([]);
  const [accountData, setAccountData] = React.useState([]);
  const { user, isReady } = useAuth();
  const userData = user;
  console.log("userData:", userData);
  const [totalCount, setTotalCount] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(20);
  const requestIdRef = React.useRef(0);

  // Filters handed over by the Executive Dashboard (Phase 2 section 8.2),
  // validated at the boundary and sent on every request.
  const location = useLocation();
  const linkFilters = React.useMemo(
    () => readAccountsLinkFilters(location.search),
    [location.search]
  );
  const linkFiltersKey = JSON.stringify(linkFilters);
  // Canonical chip labels from the backend (e.g. the region's name).
  const [appliedFilters, setAppliedFilters] = React.useState(null);

  const generateSchema = () => {
    const schema = Config.ColumnConfigs.AccountDashboard;
    const columns = [];
    for (const cur of schema) {
      if (
        cur.isDisplayed &&
        cur.isSearchable &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        // console.log("Inside AccountName Column");
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          // filteredValue: filteredInfo.AccountName || null,
          // filteredValue: [searchKeyword],
          // onFilter: (value, record) => {
          //   if (record.AccountName && record.DistributorName && record.RegionName && record.SalesYTD) {
          //     return ((record.AccountName.toLowerCase().includes(value.toLowerCase())) || (record.DistributorName.toLowerCase().includes(value.toLowerCase())) || (record.RegionName.toLowerCase().includes(value.toLowerCase())));
          //   }
          //   else {
          //     console.log("Invalid Record: ", record);
          //   }
          // },
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            if (
              typeof (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : "0" || 0) === "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              console.log("backend name: ", cur.backendName);
              console.log("strng total: ", a[`${cur.backendName}`]);
              console.log(
                "total: ",
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
              return (
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                ) -
                Number(
                  b[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            } else {
              console.log("invalid");
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (
        cur.isDisplayed &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            if (
              typeof (a[`${cur.backendName}`] ? a[`${cur.backendName}`] : 0) ===
              "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              return (
                a[`${cur.backendName}`].replace("$", "").replace(",", "") -
                b[`${cur.backendName}`].replace("$", "").replace(",", "")
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (cur.isDisplayed && cur.isSpecial) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
        });
      } else if (cur.isDisplayed && cur.isFormatter) {
        const obj = createFormatter(cur);
        columns.push(obj);
      }
    }
    console.log("Columns: ", columns);
    return columns;
  };

  const viewFunc = (index, record) => {
    return (
      <Button type="primary" style={{ background: "#ff9202" }}>
        <Link to={`/Account/${record.ID}`}>View</Link>
      </Button>
    );
  };

  const createFormatter = (cur) => {
    switch (cur.formatterType) {
      case "redirectButton": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => viewFunc(index, record),
        };
      }
    }
  };

  const formatMoney = (value) => {
    const numeric = Number.parseFloat(
      String(value ?? 0).replace(/[^0-9.-]+/g, "")
    );
    if (Number.isNaN(numeric)) return "$0.00";
    return `$${numeric.toLocaleString("en-US", {
      maximumFractionDigits: 2,
    })}`;
  };

  const formatLastDirectOrderDate = (value) => {
    if (!value) return "No orders";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "No orders";
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const normalizeAccounts = (rows) => {
    return (rows || []).map((ele) => ({
      ...ele,
      SalesYTD: formatMoney(ele?.SalesYTD),
      OpenBalance: formatMoney(ele?.OpenBalance),
      OpenBalancePastDueDate: formatMoney(ele?.OpenBalancePastDueDate),
      DaysSinceLastDirectOrder:
        ele?.DaysSinceLastDirectOrder === null ||
        ele?.DaysSinceLastDirectOrder === undefined
          ? null
          : Number(ele.DaysSinceLastDirectOrder),
    }));
  };

  const buildAccountsUrl = (page, size, query) => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("pageSize", String(size));
    if (query) params.set("q", query);
    if (linkFilters.activity) params.set("activity", linkFilters.activity);
    if (linkFilters.pastDueThreshold) {
      params.set("pastDueThreshold", linkFilters.pastDueThreshold);
    }
    if (linkFilters.activeFrom && linkFilters.activeTo) {
      params.set("activeFrom", linkFilters.activeFrom);
      params.set("activeTo", linkFilters.activeTo);
    }
    if (linkFilters.regionId) params.set("regionId", linkFilters.regionId);
    return `getaccountsdashboard?${params.toString()}`;
  };

  const fetchAccountsPage = async (page, size, query) => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    try {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        buildAccountsUrl(page, size, query)
      );
      if (requestId !== requestIdRef.current) return;
      const payload = response?.data ?? {};
      const rows = payload?.data ?? [];
      const total = payload?.totalCount ?? rows.length;
      const pages =
        payload?.totalPages ?? Math.ceil(total / (size || 1));
      setAccountData(normalizeAccounts(rows));
      setAppliedFilters(payload?.appliedFilters ?? null);
      setTotalCount(total);
      setTotalPages(pages);
    } catch (err) {
      console.error("Failed to fetch accounts dashboard data:", err);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();

  // Opens the step-by-step create-account wizard, which collects the account
  // name as the first required field of its Basics step.
  const handleNewAccount = () => navigate("/Account?tab=details");

  React.useEffect(() => {
    setColumns(generateSchema());
  }, []);

  // A new link must start on page 1.
  React.useEffect(() => {
    setCurrentPage(1);
  }, [linkFiltersKey]);

  React.useEffect(() => {
    if (!isReady) return;
    fetchAccountsPage(currentPage, pageSize, searchKeyword);
  }, [isReady, searchKeyword, currentPage, pageSize, linkFiltersKey]);

  const hasLinkFilters = Boolean(
    linkFilters.activity ||
      linkFilters.pastDueThreshold ||
      (linkFilters.activeFrom && linkFilters.activeTo) ||
      linkFilters.regionId
  );

  const clearLinkFilters = () => {
    navigate({
      pathname: location.pathname,
      search: withoutKeys(location.search, ACCOUNTS_LINK_KEYS),
    });
    setCurrentPage(1);
  };

  const handleSearch = (val) => {
    const keyword = (val || "").trim();
    setSearchKeyword(keyword);
    setCurrentPage(1);
  };

  const handlePaginationChange = (page, size) => {
    const nextSize = size || pageSize;
    const sizeChanged = nextSize !== pageSize;
    if (sizeChanged) {
      setPageSize(nextSize);
      setCurrentPage(1);
      return;
    }
    if (page !== currentPage) {
      setCurrentPage(page);
    }
  };

  const tableHeadersAccounts = [
    {
      headerName: "Account Name",
      field: "AccountName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.AccountName}
          path={`/Account/${params.data.ID}`}
        />
      ),
    },

    {
      headerName: "Distributor",
      field: "DistributorName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.DistributorName}
          path={`/Distributor/${params.data.DistributorID}`}
        />
      ),
    },
    {
      headerName: "Region",
      field: "RegionName",
      filter: true,
      isSearchable: true,
    },
    {
      headerName: "Status",
      field: "IsActive",
      cellRenderer: (params) => {
        const isActive =
          params.data?.IsActive === true ||
          params.data?.IsActive === 1 ||
          params.data?.IsActive === "1";
        return (
          <Tags
            textColor={isActive ? "successColorDark" : "failureColorDark"}
            tagBackground={isActive ? "successColorLight" : "failureColorLight"}
            tagText={isActive ? "Active" : "Deleted"}
          />
        );
      },
    },
    {
      headerName: "Orders YTD",
      field: "OrdersYTD",
      filter: true,
      cellDataType: "number",
    },
    {
      headerName: "Sales YTD",
      field: "SalesYTD",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params?.data?.SalesYTD).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.SalesYTD).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Total Purchased for all Accounts",
      field: "TotalPurchasedAllAccountsYTD",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        params.data?.CanShowTotalPurchasedAllAccounts === true
          ? Number(params.data?.TotalPurchasedAllAccountsYTD ?? 0)
          : -1,
      cellRenderer: (params) => {
        if (params.data?.CanShowTotalPurchasedAllAccounts !== true) {
          return "-";
        }
        return formatMoney(params.data?.TotalPurchasedAllAccountsYTD);
      },
    },
    {
      headerName: "Open Balance",
      field: "OpenBalance",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params.data?.OpenBalance).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data?.OpenBalance).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Past Due",
      field: "OpenBalancePastDueDate",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params.data?.OpenBalancePastDueDate).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data?.OpenBalancePastDueDate).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Days Since Last Order",
      field: "DaysSinceLastDirectOrder",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        params.data?.DaysSinceLastDirectOrder === null ||
        params.data?.DaysSinceLastDirectOrder === undefined
          ? -1
          : Number(params.data.DaysSinceLastDirectOrder),
      cellRenderer: (params) => {
        const days = params.data?.DaysSinceLastDirectOrder;
        const hasOrder = days !== null && days !== undefined;
        return (
          <div style={{ lineHeight: "18px" }}>
            <div>{hasOrder ? days : "-"}</div>
            <div style={{ color: "#6b7280", fontSize: "12px" }}>
              {formatLastDirectOrderDate(params.data?.LastDirectOrderDate)}
            </div>
          </div>
        );
      },
    },
    // OD6: only with an activity filter, so the list's default view is
    // unchanged. It explains why each account is in the list.
    ...(linkFilters.activity
      ? [
          {
            headerName: "Last Activity",
            field: "LastActivityDate",
            filter: true,
            cellRenderer: (params) => {
              const date = params.data?.LastActivityDate;
              if (!date) return "-";
              return (
                <div style={{ lineHeight: "18px" }}>
                  <div>{formatLastDirectOrderDate(date)}</div>
                  <div style={{ color: "#6b7280", fontSize: "12px" }}>
                    {params.data?.LastActivityType ?? ""}
                    {params.data?.DaysSinceLastActivity != null
                      ? ` \u00b7 ${params.data.DaysSinceLastActivity} days ago`
                      : ""}
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
    // {
    // headerName: "Action",
    // field: "",
    // sortable: false,
    // cellRenderer: (params) => (
    //   <TableOptionsCell
    //     optionOne="View"
    //     optionOneType="warning"
    //     optionOneClickPath={`/Account/${params.data.ID}`}
    //     rowData={params.data}
    //   />
    // ),
    // },
  ];
  console.log(accountData, "accountData >>>>>1");
  console.log(accountData.length, "accountData >>>>>2");
  return (
    <div style={{ display: "flex", gap: "16px", flexDirection: "column" }}>
      <TitleBar
        label="Accounts"
        invoiceNumber={
          loading ? (
            <Skeleton.Avatar
              active
              shape="circle"
              size={24}
              style={{ width: 24 }}
            />
          ) : (
            totalCount
          )
        }
        rightFilterBarComponents={
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <Input.Search
              placeholder="Search"
              // suffix={<SearchOutlined />}
              allowClear
              style={{ height: "36px" }}
              onChange={(e) => {
                if (e.target.value === "") {
                  handleSearch("");
                }
              }}
              // onSearch={value => setSearchKeyword(value)}
              onSearch={(value) => handleSearch(value)}
            />
            {canSubmitAccountEnrollment(userData) && (
              <CommonButton
                onClick={() => navigate("/AccountEnrollment")}
                variant="ghost"
              >
                New Account Enrollment
              </CommonButton>
            )}
            {userData?.Type === "Admin" && hasPermission(userData, "manage_accounts.add") && (
              <Button
                type="primary"
                onClick={handleNewAccount}
                style={{
                  background: colors["primaryColor"],
                }}
                icon={<PlusOutlined />}
                iconPosition="start"
              >
                New
              </Button>
            )}
          </div>
        }
      />

      {hasLinkFilters && (
        <FilteredViewChip
          label={filterChipLabel(linkFilters.from)}
          clearLabel={filterChipClearLabel(linkFilters.from)}
          onClear={clearLinkFilters}
          items={[
            linkFilters.activity && ACCOUNT_ACTIVITY_LABELS[linkFilters.activity],
            linkFilters.pastDueThreshold &&
              PAST_DUE_THRESHOLD_LABELS[linkFilters.pastDueThreshold],
            linkFilters.activeFrom &&
              linkFilters.activeTo &&
              `Active ${formatDateRangeLabel(linkFilters.activeFrom, linkFilters.activeTo)}`,
            linkFilters.regionId &&
              (appliedFilters?.regionName
                ? `${appliedFilters.regionName} region`
                : `Region #${linkFilters.regionId}`),
          ]}
        />
      )}

      {/* {accountData.length === 0 &&  */}
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      {/* {accountData && accountData.length > 0 && */}
      {!loading && (
        <>
          <Table
            rowData={accountData}
            columnDefs={tableHeadersAccounts}
            pagination={false}
          />
          {totalCount > 0 && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={totalCount}
                showSizeChanger
                showQuickJumper
                pageSizeOptions={["20", "50", "100"]}
                onChange={handlePaginationChange}
                onShowSizeChange={handlePaginationChange}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} of ${total}`
                }
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AccountDashboard;
